var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInbox2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "18px",
    viewBox: "0 0 22 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LV---Allar-Ferdabeidnir",
    transform: "translate(-20.000000, -182.000000)",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav",
    transform: "translate(21.000000, 166.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "inbox",
    transform: "translate(0.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    points: "20 9 14 9 12 12 8 12 6 9 0 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.47,1.19 L0,8.99999953 L0,13.9999995 C0,15.1045695 0.8954305,15.9999995 2,15.9999995 L18,15.9999995 C19.1045695,15.9999995 20,15.1045695 20,13.9999995 L20,8.99999953 L16.53,1.19 C16.2093307,0.46606538 15.4917764,-0.000540951163 14.7,-4.69852139e-07 L5.3,-4.69852139e-07 C4.5082236,-0.000540951163 3.79066933,0.46606538 3.47,1.19 Z",
    id: "Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInbox2);
export default __webpack_public_path__ + "static/media/icon-inbox-2.c02baeb78a4ceb3eb64f4ec1eda443f2.svg";
export { ForwardRef as ReactComponent };